import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/services/analytics/analyticsService";
import { usePrivacyConsent } from "@/hooks/usePrivacyConsent";

/**
 * Envia page_view sanitizado a cada rota, somente com consentimento.
 */
export function AnalyticsRouteTracker() {
  const location = useLocation();
  const { analyticsEnabled } = usePrivacyConsent();

  useEffect(() => {
    if (!analyticsEnabled) {
      return;
    }
    trackPageView(location.pathname, document.title);
  }, [location.pathname, analyticsEnabled]);

  return null;
}
